import { useState } from 'react';
import { API_CONFIG } from '../config/api';

export default function Diagnostics() {
  const [testResult, setTestResult] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  const checkEnvironmentVariables = () => {
    const results = {
      'VITE_API_WEBHOOK_URL': !!API_CONFIG.WEBHOOK_URL,
      'VITE_API_TOKEN': !!API_CONFIG.TOKEN,
      'Webhook URL': API_CONFIG.WEBHOOK_URL || 'NÃO CONFIGURADO',
      'Token presente': API_CONFIG.TOKEN ? 'SIM' : 'NÃO',
      // GOOGLE_API_KEY removido - agora está apenas no backend
    };

    setTestResult(JSON.stringify(results, null, 2));
  };

  const testWebhookConnection = async () => {
    setIsLoading(true);
    setTestResult('Testando conexão...');

    try {
      // Test with minimal payload
      const testPayload = {
        token: API_CONFIG.TOKEN,
        papel: "TESTE DIAGNÓSTICO",
        "gemini-file-url": "test://url",
        tipo: "arquivo" as const,
        base64: "dGVzdA==", // "test" in base64
        assunto: "TESTE",
        pre_analise: "TESTE DE DIAGNÓSTICO"
      };

      console.log('Enviando payload de teste:', testPayload);

      const response = await fetch(API_CONFIG.WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(testPayload)
      });

      const responseText = await response.text();
      let responseData: any;

      try {
        responseData = JSON.parse(responseText);
      } catch {
        responseData = responseText;
      }

      const result = {
        success: response.ok,
        status: response.status,
        statusText: response.statusText,
        headers: Object.fromEntries(response.headers.entries()),
        data: responseData
      };

      setTestResult(JSON.stringify(result, null, 2));
    } catch (error: any) {
      setTestResult(`ERRO: ${error.message}\n\n${error.stack}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
          Diagnóstico do Sistema
        </h1>

        <div className="space-y-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
              Variáveis de Ambiente
            </h2>
            <button
              onClick={checkEnvironmentVariables}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
            >
              Verificar Variáveis
            </button>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
              Teste de Conexão com Webhook
            </h2>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              Este teste enviará um payload mínimo para o webhook do n8n para verificar a conectividade.
              Nota: Este teste pode falhar com erro esperado, mas fornecerá informações úteis sobre a conexão.
            </p>
            <button
              onClick={testWebhookConnection}
              disabled={isLoading}
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Testando...' : 'Testar Webhook'}
            </button>
          </div>

          {testResult && (
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
              <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                Resultado
              </h2>
              <pre className="bg-gray-100 dark:bg-gray-900 p-4 rounded overflow-x-auto text-sm text-gray-800 dark:text-gray-200">
                {testResult}
              </pre>
            </div>
          )}

          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-yellow-800 dark:text-yellow-200 mb-2">
              ⚠️ Possíveis Causas do Erro 500
            </h3>
            <ul className="list-disc list-inside space-y-2 text-sm text-yellow-700 dark:text-yellow-300">
              <li>Token de API inválido ou expirado</li>
              <li>URL do arquivo Gemini expirada (URLs do Gemini expiram após algumas horas)</li>
              <li>Workflow do n8n com problema de configuração</li>
              <li>Tamanho do payload excede limite do n8n</li>
              <li>Campos obrigatórios faltando ou com formato incorreto</li>
              <li>Problemas de rede ou firewall bloqueando a requisição</li>
            </ul>
          </div>

          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-blue-800 dark:text-blue-200 mb-2">
              💡 Soluções Sugeridas
            </h3>
            <ol className="list-decimal list-inside space-y-2 text-sm text-blue-700 dark:text-blue-300">
              <li>Verifique se o token da API está correto no Netlify (Environment Variables)</li>
              <li>Teste o workflow do n8n diretamente com uma ferramenta como Postman</li>
              <li>Verifique os logs do n8n para mais detalhes sobre o erro</li>
              <li>Confirme que o workflow do n8n está ativo e acessível</li>
              <li>Verifique se há limites de tamanho de payload no n8n</li>
              <li>Tente processar um arquivo menor para testar</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}
